import React from 'react';

// Outline icons for the Templates tab, drawn on a 24-unit grid in the current
// text colour. Paths are kept here rather than inline so the palette, the
// picker and the inspector show the same mark for the same thing.
const PATHS = {
  text: ['M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12'],
  number: ['M5.25 8.25h15m-16.5 7.5h15m-1.8-13.5-3.9 19.5m-2.1-19.5-3.9 19.5'],
  date: [
    'M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5',
  ],
  select: ['M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9'],
  photo: [
    'm2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Z',
    'M14.25 8.25h.008v.008h-.008V8.25Z',
  ],
  contact: [
    'M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z',
  ],
  calculation: [
    'M8.25 6h7.5v2.25h-7.5V6Z',
    'M8.25 12h.01M12 12h.01M15.75 12h.01M8.25 15h.01M12 15h.01M15.75 15h.01M8.25 18h.01M12 18h.01M15.75 18h.01',
    'M6.75 2.25h10.5a2.25 2.25 0 0 1 2.25 2.25v15a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5v-15a2.25 2.25 0 0 1 2.25-2.25Z',
  ],
  typed: ['M5.25 6.75V4.5h13.5v2.25M12 4.5v15m-3 0h6'],
  document: [
    'M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z',
  ],
  tag: [
    'M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z',
    'M6 6h.008v.008H6V6Z',
  ],
  blank: ['M3.75 3.75h4.5m7.5 0h4.5v4.5m0 7.5v4.5h-4.5m-7.5 0h-4.5v-4.5m0-7.5v-4.5'],
  undo: ['M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3'],
  redo: ['m15 15 6-6m0 0-6-6m6 6H9a6 6 0 0 0 0 12h3'],
  copy: [
    'M16.5 8.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v8.25A2.25 2.25 0 0 0 6 16.5h2.25m8.25-8.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-7.5A2.25 2.25 0 0 1 8.25 18v-1.5m8.25-8.25h-6a2.25 2.25 0 0 0-2.25 2.25v6',
  ],
  trash: [
    'm14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0',
  ],
  pencil: [
    'm16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10',
  ],
  search: ['m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z'],
  back: ['M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18'],
  check: ['m4.5 12.75 6 6 9-13.5'],
  warning: [
    'M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z',
  ],
  swap: ['M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5'],
  alignLeft: ['M3.75 6h16.5M3.75 10.5h10.5M3.75 15h16.5M3.75 19.5h10.5'],
  alignCenter: ['M3.75 6h16.5M6.75 10.5h10.5M3.75 15h16.5M6.75 19.5h10.5'],
  alignRight: ['M3.75 6h16.5M9.75 10.5h10.5M3.75 15h16.5M9.75 19.5h10.5'],
};

export const Icon = ({ name, className = 'w-4 h-4', strokeWidth = 1.5 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {(PATHS[name] || PATHS.blank).map((d) => <path key={d} d={d} />)}
  </svg>
);

const DETAIL_ICONS = {
  title: 'tag',
  submitted_at: 'date',
  submitter: 'contact',
  form_name: 'document',
};

// The icon for whatever fills a box or a palette entry.
export const sourceIconName = ({ kind, field, detail }) => {
  if (kind === 'text') return 'typed';
  if (kind === 'detail') return DETAIL_ICONS[detail] || 'document';
  return PATHS[field?.type] ? field.type : 'text';
};

// The tick and cross a checkmark box prints, as strokes across a 20-unit
// square: each stroke is the points it runs through. Drawn rather than typed,
// so the mark is the same in every font — the PDF's built-in fonts have no ✓ —
// and the PDF renderer draws these same strokes.
export const MARK_GRID = 20;
export const MARK_STROKE_WIDTH = 2.5;
const MARK_STROKES = {
  check: [[[4, 10.5], [8, 14.5], [16, 6]]],
  x: [[[5, 5], [15, 15]], [[15, 5], [5, 15]]],
};

export const markStrokesFor = (mark) => MARK_STROKES[mark === 'x' ? 'x' : 'check'];

const strokePath = (strokes) =>
  strokes.map((points) => points.map(([x, y], index) => `${index ? 'L' : 'M'}${x} ${y}`).join('')).join('');

export const Mark = ({ mark, className }) => (
  <svg
    viewBox={`0 0 ${MARK_GRID} ${MARK_GRID}`}
    fill="none"
    stroke="currentColor"
    strokeWidth={MARK_STROKE_WIDTH}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <path d={strokePath(markStrokesFor(mark))} />
  </svg>
);
